import {AuthOptions} from "@aws-amplify/auth/lib/types";
import {Auth, I18n} from "aws-amplify";

const config: {
    graphqlUrl: string
    region: string
    Auth: AuthOptions
    API: {
        endpoints: {
            name: string
            endpoint: string
            custom_header?: Function
        }[]
    }
} = {
    graphqlUrl: 'https://ivmfegchwfhk5bic6n4qif5ii4.appsync-api.eu-west-1.amazonaws.com/graphql',
    region: 'eu-west-1',

    Auth: {
        userPoolId: 'eu-west-1_AMeXEMsh0',
        userPoolWebClientId: 'gbkaktqer79964g3mc2mn3ldg',
        region: 'eu-west-1',
        mandatorySignIn: true,
        authenticationFlowType: 'USER_PASSWORD_AUTH'
    },

    API: {
        endpoints: [
            {
                name: 'DynamoIt',
                endpoint: '/api',
                custom_header: async () => {
                    console.log(`${(await Auth.currentSession()).getAccessToken().getJwtToken()}`)
                    // return {Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`}
                    return {Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`}
                }
            }
        ]
    }
}

I18n.putVocabularies({
    en: {
        'Scan then enter verification code': 'Scan then enter verification code (You can use any TOTP application, for example Google Authenticator)'
    }
})
I18n.setLanguage('en')

export default config
